import { format, addMinutes } from "date-fns";

export const formatDate = (date, pattern) => {
    return format(addMinutes(new Date(date), new Date(date).getTimezoneOffset()), pattern);
}